__turbopack_context__.v({
  "ConfigPanel": "FrJWGq_ConfigPanel",
  "Container": "FrJWGq_Container",
  "DismissButton": "FrJWGq_DismissButton",
  "PreviewPanel": "FrJWGq_PreviewPanel",
  "RestoreButton": "FrJWGq_RestoreButton",
  "RestorePrompt": "FrJWGq_RestorePrompt",
  "RestorePromptActions": "FrJWGq_RestorePromptActions",
  "RestorePromptContent": "FrJWGq_RestorePromptContent",
  "Root": "FrJWGq_Root",
  "skeleton-loading": "FrJWGq_skeleton-loading",
});
